<template>
  <div>
    <a-form-item :wrapper-col="{ span: 24 }">
      <a-textarea
        :placeholder="placeholderText"
        :rows="rows"
        :style="{ color: validateStatus === 'error' ? 'red' : '' }"
        v-model.trim="inputValue"
        @blur="handleModules"
      />
    </a-form-item>

    <a-form-item label="模组总数" :style="{ display: 'inline-block', width: '50%' }">
      <span class="modules-count">{{ modulesCount }}</span>
    </a-form-item>

    <a-form-item label="重复数量" :style="{ display: 'inline-block', width: '50%' }">
      <span class="modules-count">{{ duplicateModulesCount }}</span>
    </a-form-item>
  </div>
</template>

<script>
import { analyzeModules, formatModuleInputValue, maxModuleLines } from '@/utils/module'

export default {
  name: 'CommonModuleInput',
  props: {
    rows: {
      type: Number,
      default: 10
    },
    // import: 入库，仅 IMEI 必填；imei: 划拨/查询，仅 IMEI
    mode: {
      type: String,
      default: 'imei',
      validator(value) {
        return ['import', 'imei'].includes(value)
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    value: {
      type: Object
    }
  },
  data() {
    const value = this.value || {}

    if (!value.inputValue && Array.isArray(value.data) && value.data.length > 0) {
      value.inputValue = formatModuleInputValue(value.data, this.mode)
    }

    return {
      inValue: {},
      modulesCount: 0,
      duplicateModulesCount: 0,
      inputValue: value.inputValue || '',
      data: value.data || [],
      validateStatus: 'success',
      errorMsg: ''
    }
  },
  computed: {
    placeholderText() {
      if (this.mode === 'import') {
        return '可以直接复制 excel 中整列 IMEI；\n' +
          '手动输入多个模组，一行一个 IMEI；\n' +
          '如需填写 SN、箱号、盘号，使用 IMEI|SN|箱号|盘号 格式，后三项可留空。\n' +
          '例如: 860123456789012 或 860123456789012|SN001|BOX001|REEL001'
      }

      return '可以直接复制 excel 中整列 IMEI；\n' +
        '手动输入多个模组，一行一个 IMEI。\n' +
        '例如: 860123456789012'
    }
  },
  watch: {
    value(val = {}) {
      this.inputValue = val.inputValue
      this.data = val.data
    }
  },
  created() {
    if (this.value) {
      this.inValue = this.value
    }

    if (this.inputValue) {
      this.handleModules()
    }
  },
  methods: {
    initData() {
      if (this.inValue) {
        this.inputValue = this.inValue.inputValue
        this.data = this.inValue.data
      }
    },

    triggerChange() {
      this.$emit('change', Object.assign({}, this.$data))
    },

    handleModules() {
      this.validateModules()
      this.triggerChange()
    },

    validateModules() {
      if (!this.inputValue) {
        this.validateStatus = 'error'
        this.errorMsg = '请输入模组信息'
        this.modulesCount = 0
        this.duplicateModulesCount = 0
        this.data = []
        return
      }

      const { lines, validModules, errorText } = analyzeModules(this.inputValue, { mode: this.mode })

      if (lines > maxModuleLines) {
        this.validateStatus = 'error'
        this.errorMsg = `模组数量不能超过${maxModuleLines}`
        return
      }

      if (errorText) {
        this.validateStatus = 'error'
        this.errorMsg = '模组信息包含错误，无法提交'
      } else {
        this.validateStatus = 'success'
        this.errorMsg = null
      }

      this.inputValue = errorText + formatModuleInputValue(validModules, this.mode)
      this.modulesCount = validModules.length
      this.data = this.$lodash.uniqBy(validModules, 'imei')
      this.duplicateModulesCount = validModules.length - this.data.length
    }
  }
}
</script>

<style lang="less" scoped>
.modules-count {
  padding-left: 20px;
}
</style>
